import { MutableRefObject, useCallback } from "react";

/**
 * Inserts a `{token}` into the active draft at the composer's caret, and puts the caret right
 * after it; appends at the end when the textarea is not mounted. Moved out of `useAddInboxChat`.
 */
export const useInsertVariableAtCaret = (
	composerRef: MutableRefObject<HTMLTextAreaElement | null>,
	content: string,
	setMessage: (value: string) => void
) =>
	useCallback(
		(key: string) => {
			const token = `{${key}}`;
			const textarea = composerRef.current;

			if (!textarea) {
				setMessage(content + token);

				return;
			}

			const start = textarea.selectionStart ?? content.length;
			const end = textarea.selectionEnd ?? content.length;

			setMessage(content.slice(0, start) + token + content.slice(end));

			// Restore the caret just after the inserted token once the controlled value has been
			// re-rendered (focus() forces the caret to the end, so we override it afterwards).
			const caret = start + token.length;

			window.requestAnimationFrame(() => {
				textarea.focus();
				textarea.setSelectionRange(caret, caret);
			});
		},
		[composerRef, content, setMessage]
	);
